import { useIntl } from '@/intl'
import { PropsWithChildren, useState } from 'react'
import { Tag } from '@workwave-tidal/core/components'

type MixedTagProps = PropsWithChildren<{}>

export function MixedTag(props: MixedTagProps) {
  const texts = useTexts()
  const { children = texts.mixedLabel } = props

  return <Tag mode="squared" label={children} sx={{ borderSize: 0, background: 'transparent' }} />
}

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    mixedLabel: translate({ id: 'global.plusMixed' }),
  }))

  return api
}
